document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('#FacetedFiltersForm1');
  const products = document.querySelectorAll('.grid__item');

  const handleize = str =>
    str.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    const activeFilters = {};
    const checkboxes = form.querySelectorAll('input[type="checkbox"]:checked');

    checkboxes.forEach(cb => {
      const name = cb.name.split('.').pop().replace(/_/g, '-');
      const value = handleize(cb.value);

      if (!activeFilters[name]) activeFilters[name] = [];
      activeFilters[name].push(value);
    });

    const minPrice = parseFloat(form.querySelector('input[name$=".gte"]')?.value || 0);
    const maxPrice = parseFloat(form.querySelector('input[name$=".lte"]')?.value || Infinity);

    products.forEach(product => {
      let visible = true;

      for (const filter in activeFilters) {
        const attrName = `data-${filter}`;
        const attrValue = product.getAttribute(attrName);

        if (!attrValue) {
          visible = false;
          break;
        }

        let productValues;

        if (filter === 'size') {
          productValues = attrValue.split('-').map(v => v.trim());
        } else {
          productValues = attrValue.split(',').map(v => v.trim());
        }
        const filterValues = activeFilters[filter];

        const match = filterValues.some(val => productValues.includes(val));
        if (!match) {
          visible = false;
          break;
        }
      }

      const price = parseFloat(product.dataset.price || 0);
      if (price < minPrice || price > maxPrice) visible = false;

      product.style.display = visible ? '' : 'none';
    });
  });

  // Trigger on change (checkbox/select)
  form.addEventListener('change', () => form.dispatchEvent(new Event('submit')));

  // Trigger on price typing
  const priceInputs = form.querySelectorAll('input[name$=".gte"], input[name$=".lte"]');
  priceInputs.forEach(input => {
    input.addEventListener('input', () => form.dispatchEvent(new Event('submit')));
  });
});
